import React from "react";
import Marty from "marty";
import MailingList from "../../../components/MailingList";

let Pro = React.createClass({
    render() {
        return (
          <section className="eo-view pro grid-10 parent">
              <div className="bg-image" />
              <div className="eo-padded-wrapper">
                  <section className="one-router-model grid-4 grid-s-10 eo-section eo-info-panel">
                      <h2>eero for professionals,<br/>coming soon</h2>
                      <p>Homeowners love eero features like guest access, family management and robust automated security. Integrators love eero because it's quick and easy to install and customers don't call back for service issues.</p>
                      <p>Sign up here to get early access to distribution, program details and discounted pricing for professionals.</p>
                      <p>We look forward to working with you.</p>
                      <MailingList
                        placeholder="Email Address"
                        successMessage="Thanks, we'll be in touch."
                        replace={true}
                        pro={true} />
                  </section>
              </div>
          </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(Pro, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/pro/Handler.js
 **/